import styled from 'styled-components';
import { Modal, ModalTitle, ModalBody, ModalFooter } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';

const SpacedContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export type InitiationSuccessModalProps = {
  onClose: () => void;
};

/**
 * Success modal after initiating an enrollment that does not require a signature.
 */
export const InitiationSuccessModal = ({ onClose }: InitiationSuccessModalProps) => {
  return (
    <Modal onClose={onClose}>
      <ModalTitle>Enrollment is now pending</ModalTitle>
      <ModalBody>
        <SpacedContent>
          <Typography styledAs="bodyLargeDMSans">
            We'll complete the remaining sections using the information from the prescription and notify you when the
            form is ready to be reviewed for provider signature.
          </Typography>
          <Typography styledAs="bodyLargeDMSans">
            You can review this and other pending forms at the top of the Prescriptions page.
          </Typography>
        </SpacedContent>
      </ModalBody>
      <ModalFooter>
        <Button to="/prescriptions">Return to Prescriptions</Button>
        <Button variant="secondary" onClick={() => location.reload()}>
          View pending form
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default InitiationSuccessModal;
